import {Answer} from 'Event/SubmissionsProvider'
import {Form} from 'organization/Event/FormsProvider'
import {
  isQuestionWithOptions,
  Question,
} from 'organization/Event/QuestionsProvider'
import {uuid} from 'lib/uuid'

export function cleanAttendeeAnswers(answers: Answer[], forms: Form[]) {
  const cleaned: Answer[] = []

  for (const answer of answers) {
    const form = forms.find((f) => f.id === answer.form_id)
    const question = form?.questions.find((q) => q.id === answer.question_id)
    if (!question) {
      continue
    }

    const value = removeDeletedOptions(question, answer.value)
    if (!value) {
      continue
    }

    cleaned.push({...answer, value})
  }

  return cleaned
}

export function prefillAnswer(answer: Answer, attendeeAnswers: Answer[]) {
  const submitted = attendeeAnswers.find(
    (a) => a.question_id === answer.question_id,
  )
  if (!submitted) {
    return {...answer, id: uuid(), value: ''}
  }

  return {...answer, id: uuid(), value: submitted.value}
}

function removeDeletedOptions(question: Question, value: string) {
  if (!isQuestionWithOptions(question)) {
    return value
  }

  const options = question.options.map((option) => option.value)
  if (options.includes(value)) {
    return value
  }

  return value
    .split(', ')
    .filter((v) => options.includes(v))
    .join(', ')
}
